$(document).ready(function() {
    $('.img-grid-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
       asNavFor: '.slider-nav_img',
        responsive: [{         
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                centerMode: true,              
                slidesToScroll: 1
            }
        }]
    });

  $('.slider-nav_img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.img-grid-slider',
  dots: false,  
    fade: true,
  arrows: false,
  centerMode: false,
  focusOnSelect: true
});

$('.hovergrid-1').hover(function(){
  $('.imggrid-text-1').addClass("active");
  $('.imggrid-text-2').removeClass("active");
  $('.imggrid-text-3').removeClass("active");
  $('.imggrid-text-4').removeClass("active");

  $(this).addClass("active");
   $('.hovergrid-2').removeClass("active");
   $('.hovergrid-3').removeClass("active");
   $('.hovergrid-4').removeClass("active");
});
$('.hovergrid-2').hover(function(){
  $('.imggrid-text-1').removeClass("active");
  $('.imggrid-text-2').addClass("active");
  $('.imggrid-text-3').removeClass("active");
  $('.imggrid-text-4').removeClass("active");
  $(this).addClass("active");
   $('.hovergrid-1').removeClass("active");
   $('.hovergrid-3').removeClass("active");
   $('.hovergrid-4').removeClass("active");
});
  $('.hovergrid-3').hover(function(){
  $('.imggrid-text-1').removeClass("active");
  $('.imggrid-text-2').removeClass("active");
  $('.imggrid-text-3').addClass("active");
  $('.imggrid-text-4').removeClass("active");
    $(this).addClass("active");
   $('.hovergrid-1').removeClass("active");
   $('.hovergrid-2').removeClass("active");
   $('.hovergrid-4').removeClass("active");
});
    $('.hovergrid-4').hover(function(){
  $('.imggrid-text-1').removeClass("active");
  $('.imggrid-text-2').removeClass("active");
  $('.imggrid-text-3').removeClass("active");
  $('.imggrid-text-4').addClass("active");
      $(this).addClass("active");
   $('.hovergrid-1').removeClass("active");
   $('.hovergrid-2').removeClass("active");
   $('.hovergrid-3').removeClass("active");
});


$(".product-sizebox .yotpo-widget-instance").click(function() {
    $('html,body').animate({                                                       
        scrollTop: $(".yotpo-main-widget").offset().top - 110},
        2000);
});
  
  
  });